import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
    Tabs, Tab, Typography, Box, InputLabel, MenuItem, FormControl, Select, Stack, Grid, styled,
} from '@mui/material';
import AqiSitesReportForm from './AqiSitesReportForm';
import Alarm from './Alarm';
import ServerUtilization from './ServerUtilization';
import FirmwareVersion from './FirmwareVersion';
import BumpTest from './BumpTest';
import SensorStatus from './SensorStatus';
import DeviceLogs from './DeviceLogs';
import SoftwareVersion from './SoftwareVersion';

import {
    FetchLocationService,
    FetchBranchService,
    FetchFacilitiyService,
    BuildingFetchService,
    FloorfetchService,
    LabfetchService,
    DeviceFetchService,
    SearchDeviceDataService,
} from '../../services/LoginPageService';
import HardwareModelVersion from './HardwareModelVersion';

function TabPanel(props) {
    const { children, value, index } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

// export default function ManagementReportTab() {
const ManagementReportTab = () => {
    const [location_id, setLocation_id] = useState('');
    const [locationList, setLocationList] = useState([]);
    const [branch_id, setBranch_id] = useState('');
    const [branchList, setBranchList] = useState([]);
    const [facility_id, setFacility_id] = useState('');
    const [facilityList, setFacilityList] = useState([]);
    const [building_id, setBuilding_id] = useState('');
    const [buildingList, setBuildingList] = useState([]);
    const [floor_id, setFloor_id] = useState('');
    const [floorList, setFloorList] = useState([]);
    const [lab_id, setLab_id] = useState('');
    const [labList, setLabList] = useState([]);
    const [device_id, setDevice_id] = useState('');
    const [deviceList, setDeviceList] = useState([]);

    useEffect(() => {
        loadLocation();
    }, []);

    useEffect(() => {
        SearchDeviceDataService({
            location_id, branch_id, facility_id, building_id, floor_id, lab_id,
        }, DeviceHandleSuccess, DeviceHandleException);
    }, [location_id, branch_id, facility_id, building_id, floor_id, lab_id ]);

    const loadLocation = () => {
        FetchLocationService(LocationHandleSuccess, LocationHandleException);
    };

    const LocationHandleSuccess = (dataObject) => {
        setLocationList(dataObject.data || []);
    };
    const LocationHandleException = () => { };

    const LocationChanged = (location_id) => {
        setLocation_id(location_id);
        setBranch_id('');
        setFacility_id('');
        setBuilding_id('');
        setFloor_id('');
        setLab_id('');
        setBranchList([]);
        setFacilityList([]);
        setBuildingList([]);
        setFloorList([]);
        setLabList([]);
        if(location_id){
            FetchBranchService({ location_id }, BranchHandleSuccess, BranchHandleException);
        }
    };

    const BranchHandleSuccess = (dataObject) => {
        setBranchList(dataObject.data || []);
    };
    const BranchHandleException = () => { };

    const BranchChanged = (branch_id) => {
        setBranch_id(branch_id);
        setFacility_id('');
        setBuilding_id('');
        setFloor_id('');
        setLab_id('');
        setFacilityList([]);
        setBuildingList([]);
        setFloorList([]);
        setLabList([]);
        if(branch_id){
            FetchFacilitiyService({ location_id, branch_id }, FacilityHandleSuccess, FacilityHandleException);
        }
    };
    const FacilityHandleSuccess = (dataObject) => {
        setFacilityList(dataObject.data || []);
    };

    const FacilityHandleException = () => { };

    const FacilityChanged = (facility_id) => {
        setFacility_id(facility_id);
        setBuilding_id('');
        setFloor_id('');
        setLab_id('');
        setBuildingList([]);
        setFloorList([]);
        setLabList([]);
        if(facility_id){
            BuildingFetchService({ location_id, branch_id, facility_id }, BuildingHandleSuccess, BuildingHandleException);
        }
    };

    const BuildingHandleSuccess = (dataObject) => {
        setBuildingList(dataObject.data || []);
    };

    const BuildingHandleException = () => { };

    const BuildingChanged = (building_id) => {
        setBuilding_id(building_id);
        setFloor_id('');
        setLab_id('');
        setFloorList([]);
        setLabList([]);
        if(building_id){
            FloorfetchService({
                location_id, branch_id, facility_id, building_id,
            }, FloorHandleSuccess, FloorHandleException);
        }
    };

    const FloorHandleSuccess = (dataObject) => {
        setFloorList(dataObject.data || []);
    };
    const FloorHandleException = () => { };

    const FloorChanged = (floor_id) => {
        setFloor_id(floor_id);
        setLab_id('');
        setLabList([]);
        if(floor_id){
            LabfetchService({
                location_id, branch_id, facility_id, building_id, floor_id,
            }, LabHandleSuccess, LabHandleException);
        }
    };

    const LabHandleSuccess = (dataObject) => {
        setLabList(dataObject.data || []);
    };

    const LabHandleException = () => { };

    const LabHandleChange = (lab_id) => {
        setLab_id(lab_id);
        // if(lab_id){
        //     SearchDeviceDataService({
        //         location_id, branch_id, facility_id, building_id, floor_id, lab_id,
        //     }, DeviceHandleSuccess, DeviceHandleException);
        // }
    };

    const DeviceHandleSuccess = (dataObject) => {
        setDeviceList(dataObject.data || []);
    };
    const DeviceHandleException = () => { };

    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <>
        <Grid container spacing={1} style={{ height: '94vh', width: '100%', padding: 2, marginLeft: '0px', marginTop: '0px' }}>
            <div style={{
                height: '94vh',
                width: '100%',
                overflow: 'auto'
            }}>
                <Grid container spacing={1} xs={12} style={{
                    marginTop: 2
                }}>
                    <Grid item 
                        xs={6}
                        sm={4}
                        md={4}
                        lg={3}
                        xl={2}
                    >
                        <FormControl fullWidth size="small">
                            <InputLabel>Location</InputLabel>
                            <Select
                                value={location_id}
                                label="Location"
                                onChange={(e) => {
                                    LocationChanged(e.target.value);
                                }}
                            >
                                <MenuItem value="" key={0}>
                                    <em style={{fontWeight: 'bold'}}>All</em>
                                </MenuItem>
                                {locationList.map((data, index) => (
                                    <MenuItem value={data.id} key={index + 1}>{data.stateName}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item 
                        xs={6}
                        sm={4}
                        md={4}
                        lg={3}
                        xl={2}>
                        <FormControl fullWidth size="small" >
                            <InputLabel>Branch</InputLabel>
                            <Select
                                value={branch_id}
                                label="Branch"
                                onChange={(e) => {
                                    BranchChanged(e.target.value);
                                }}
                            >
                                <MenuItem value="" key={0}>
                                    <em style={{fontWeight: 'bold'}}>All</em>
                                </MenuItem>
                                {branchList.map((data, index) => (
                                    <MenuItem value={data.id} key={index + 1}>{data.branchName}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item
                        xs={6}
                        sm={4}
                        md={4}
                        lg={3}
                        xl={2}
                    >
                        <FormControl fullWidth size="small" >
                            <InputLabel>Facility</InputLabel>
                            <Select
                                value={facility_id}
                                label="Facility"
                                onChange={(e) => {
                                    FacilityChanged(e.target.value);
                                }}
                            >
                                <MenuItem value="" key={0}>
                                    <em style={{fontWeight: 'bold'}}>All</em>
                                </MenuItem>
                                {facilityList.map((data, index) => (
                                    <MenuItem value={data.id} key={index + 1}>{data.facilityName}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item 
                        xs={6}
                        sm={4}
                        md={4}
                        lg={3}
                        xl={2}
                    >
                        <FormControl fullWidth size="small" >
                            <InputLabel>Building</InputLabel>
                            <Select
                                value={building_id}
                                label="Building"
                                onChange={(e) => {
                                    BuildingChanged(e.target.value);
                                }}
                            >
                                <MenuItem value="" key={0}>
                                    <em style={{fontWeight: 'bold'}}>All</em>
                                </MenuItem>
                                {buildingList.map((data, index) => (
                                    <MenuItem value={data.id} key={index + 1}>{data.buildingName}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item
                        xs={6}
                        sm={4}
                        md={4}
                        lg={3}
                        xl={2}
                    >
                        <FormControl fullWidth size="small" >
                            <InputLabel>Floor</InputLabel>
                            <Select
                                value={floor_id}
                                label="Floor"
                                onChange={(e) => {
                                    FloorChanged(e.target.value);
                                }}
                            >
                                <MenuItem value="" key={0}>
                                    <em style={{fontWeight: 'bold'}}>All</em>
                                </MenuItem>
                                {floorList.map((data, index) => (
                                    <MenuItem value={data.id} key={index + 1}>{data.floorName}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item
                        xs={6}
                        sm={4}
                        md={4}
                        lg={3}
                        xl={2}
                    >
                        <FormControl fullWidth size="small" >
                            <InputLabel>Zone</InputLabel>
                            <Select
                                value={lab_id}
                                label="Zone"
                                onChange={(e) => {
                                    LabHandleChange(e.target.value);
                                }}
                            >
                                <MenuItem value="" key={0}>
                                    <em style={{fontWeight: 'bold'}}>All</em>
                                </MenuItem>
                                {labList.map((data, index) => (
                                    <MenuItem value={data.id} key={index + 1}>{data.labDepName}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container >
                    <Grid item style={{
                        width: '100%',
                        overflow: 'auto'
                    }}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider', overflow: 'auto' }} >
                            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example"
                                // scrollButtons="off"
                                variant='scrollable'
                                visibleScrollbar={true}
                                allowScrollButtonsMobile
                                style={{overflow: 'auto',
                                    width:'82vw'
                                }}
                            >
                                <Tab label="Air Quality Index" {...a11yProps(0)} />
                                <Tab label="Sensor Status" {...a11yProps(1)} />
                                <Tab label="Alarms" {...a11yProps(2)} />
                                <Tab label="Limit Edit Logs" {...a11yProps(3)} />
                                <Tab label="Server Utilization" {...a11yProps(4)} />
                                <Tab label="Application version" {...a11yProps(5)} />
                                <Tab label="Firmware Version" {...a11yProps(6)} />
                                <Tab label="H/W Model No" {...a11yProps(7)} />
                                <Tab label="BumpTest" {...a11yProps(8)} /> 
                            </Tabs>
                        </Box>
                        <TabPanel value={value} index={0}>
                            <AqiSitesReportForm 
                                siteId ={{location_id, branch_id, facility_id, building_id, floor_id, lab_id}}
                                deviceList={deviceList}
                            />
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            <SensorStatus 
                                deviceList={deviceList} 
                                siteId ={{location_id, branch_id, facility_id, building_id, floor_id, lab_id}}
                            />
                        </TabPanel>
                        <TabPanel value={value} index={2}>
                            <Alarm 
                                siteId ={{location_id, branch_id, facility_id, building_id, floor_id, lab_id}}
                                deviceList={deviceList} 
                            />
                        </TabPanel>
                        <TabPanel value={value} index={3}>
                            <DeviceLogs 
                                deviceList={deviceList}
                                siteId ={{location_id, branch_id, facility_id, building_id, floor_id, lab_id}}
                            />
                        </TabPanel>
                        <TabPanel value={value} index={4}>
                            <ServerUtilization />
                        </TabPanel>
                        <TabPanel value={value} index={5}>
                            <SoftwareVersion />
                        </TabPanel>
                        <TabPanel value={value} index={6}>
                            <FirmwareVersion 
                                deviceList={deviceList}
                                siteId ={{location_id, branch_id, facility_id, building_id, floor_id, lab_id}}
                            />
                        </TabPanel>
                        <TabPanel value={value} index={7}>
                            <HardwareModelVersion 
                                deviceList={deviceList}
                                siteId ={{location_id, branch_id, facility_id, building_id, floor_id, lab_id}} /
                            >
                        </TabPanel>
                        <TabPanel value={value} index={8}>
                            <BumpTest 
                                deviceList={deviceList} 
                                siteId ={{location_id, branch_id, facility_id, building_id, floor_id, lab_id}}
                            />
                        </TabPanel>
                    </Grid>
                </Grid>
            </div>
        </Grid>
        </>
    );
};
export default ManagementReportTab;